module.exports = __webpack_public_path__ + "img/chat.e1dbaef6.svg";